import React from 'react';
import RequestsAndMatchingPage from './RequestsAndMatchingPage';
// Isolate the standalone request form from inherited modal sizing and scrolling.
import './NewRequestPage.css';

// Reuse the single complete internal request form in standalone creation mode.
const NewRequestPage = () => <RequestsAndMatchingPage creationMode />;

export default NewRequestPage;
